const ONE_MINUTE = 60_000;
const ONE_HOUR = 60 * 60_000;
export const SUB_TREE_SYNC_INTERVAL = __DEV__ ? ONE_MINUTE : ONE_HOUR;
export const EXAM_LEVEL_SYNC_INTERVAL = __DEV__ ? ONE_MINUTE : 5 * ONE_HOUR;
export const COMMUNITY_SYNC_INTERVAL = __DEV__ ? ONE_MINUTE : 5 * ONE_HOUR;
export const NODE_USER_SYNC_INTERVAL = __DEV__ ? ONE_MINUTE : ONE_HOUR;
